/* eslint-disable react-refresh/only-export-components */
import { Stack } from '@mui/material';
import FormStepper from './FormStepper';
import { collection, DocumentData } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { useCollection } from 'react-firebase-hooks/firestore';
import { db } from '../../firebase-setup/firebase';
import '../../App.css';
import { formConfigField } from '../../utils/types';

export const requiredFields = (field: formConfigField, value: string) => {
  if (field.required && value === '') {
    return 'This field is required';
  }
  return '';
};

function ApplyForm() {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  let source = searchParams.get('utm_campaign');
  const sessionId = searchParams.get('sessionId');
  if (!source || source === '') {
    source = 'website';
  }
  if (window.location.href.includes('fym') ||  process.env.NODE_ENV === 'development') {
    source = 'fym';
  }
  const isMedicare = searchParams.get('company') === 'medicare';
  const [medications, loadingMedications] = useCollection(
    collection(db, 'medications'),
    {
      snapshotListenOptions: { includeMetadataChanges: false },
    }
  );
  const [medicationsList, setMedicationsList] = useState<DocumentData[] | null>(
    null
  );
  let isMedicareOnly = false;
  switch (source) {
    case 'uip':
      isMedicareOnly = true;
      break;
    case 'delta':
      isMedicareOnly = true;
      break;
    case 'sterling':
      isMedicareOnly = true;
      break;
    case 'abi':
      isMedicareOnly = true;
      break;
    case 'fenyx':
      isMedicareOnly = true;
      break;
    case 'fym':
      isMedicareOnly = true;
      break;
  }

  useEffect(() => {
    if (loadingMedications || !medications) return;
    let orderdList = medications.docs.map((doc) => doc.data());
    orderdList = orderdList.sort((a, b) => {
      if (a.name > b.name) return 1;
      if (a.name < b.name) return -1;
      return 0;
    });
    if (isMedicareOnly || isMedicare) {
      orderdList = orderdList.filter((med) => med.brand);
    }

    // Filter out medications that are not available for the selected source
    const hiddenMeds = [
      'Avycaz',
      'Dalvance',
      'Teflaro',
      'Depakote',
      'Imbruvica',
      'Lupin Depot',
      'Mavyret',
      'Orhiann',
      'Orilissa',
      'Vyalev',
    ];
    orderdList = orderdList.filter((med) => !hiddenMeds.includes(med.name));
    setMedicationsList(orderdList);
  }, [isMedicare, isMedicareOnly, loadingMedications, medications]);

  const [insuranceData, loadingInsuranceData] = useCollection(
    collection(db, 'insuranceCompanies'),
    {
      snapshotListenOptions: { includeMetadataChanges: false },
    }
  );
  useEffect(() => {
    if (loadingInsuranceData) return;
    let orderdList = insuranceData?.docs.map((doc) => doc.data());
    orderdList = orderdList?.sort((a, b) => {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    setInsuranceDataList(orderdList!);
  }, [loadingInsuranceData, insuranceData]);
  const [insuranceDataList, setInsuranceDataList] = useState<
    DocumentData[] | null
  >(null);
  return (
    <Stack
      className="container"
      sx={{
        paddingTop: {
          xs: 2,
          md: 8,
        },
      }}>
      {!loadingMedications &&
      !loadingInsuranceData &&
      medicationsList &&
      medicationsList!.length > 0 ? (
        <FormStepper
          medicationsList={medicationsList}
          insuranceDataList={insuranceDataList}
          isMedicareOnly={isMedicareOnly}
          source={source}
          sessionId={sessionId || ''}
        />
      ) : (
        <div className="loader-s">
          <div className="loader" />
        </div>
      )}
    </Stack>
  );
}

export default ApplyForm;
